import React ,{useEffect, useState} from 'react';
import './Career.css';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import AOS from 'aos';
import OpeningPopUp from './OpeningPopUp';
import CancelIcon from '@mui/icons-material/Cancel';


const Career = () => {
  const [openingStatus,setOpeningStatus]=useState(false);
    useEffect(() => {
        AOS.init();
          window.scrollTo(0, 0)
      }, [])
  return (
    <div className='container-fluid' id='career-page'>
      <div className="row first-row">
        <div className="col top-row" data-aos="fade-up" data-aos-offset="0"  data-aos-duration="1000"	>
            <h1 >"Explore Exciting Opportunities to Grow Your Career with Us Today!"</h1>
            <div className="btn" onClick={()=>setOpeningStatus(true)}>
                Current Opening 
            </div>
            

        </div>
        {openingStatus && <div id="close-btn-for-openings" onClick={()=>setOpeningStatus(false)}>
        <CancelIcon/>
        </div>
        }
        {openingStatus && <OpeningPopUp/>}
        <div className="col bottom-row" data-aos="fade-up" data-aos-offset="0"  data-aos-duration="1000"	>
           <h1>Join the Unique Technologies team and be part of something special</h1>
           <p>At Unique Technologies we consistently strive to provide the opportunity to grow and develop both personally and professionally – giving our team the winning edge</p>
        </div>
      </div>
      <div className="row second-row">
        <div className="col top-row">
            {/* <h1>"Explore Exciting Opportunities to Grow Your Career with Us Today!"</h1>
            <div className="btn">
                Current Opening 
            </div> */}

        </div>
        <div className="col bottom-row" data-aos="fade-up" data-aos-offset="200"  data-aos-duration="1000"	>
           <h1>Fostered by Talent, Ignited by Passion: Join Us Beyond Boundaries!</h1>
           <p>
"We prioritize dedication and a resilient spirit over university credentials. Your skills and commitment to excellence matter most to us, fostering an inclusive environment where everyone's potential is valued and nurtured, regardless of educational background. Join us and thrive based on your merits and determination."</p>
        </div>
      </div>
      <div className="row third-row">
        <div className="col left-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000"	>
        <RocketLaunchIcon className='left-icon'/>
        <p>Share your talents <br /> and make an impact</p>
        </div>
        <div className="col right-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000"	>
            <h1>Career Appeal Form</h1>
            <form action="https://formspree.io/f/xpzvrnlw"
  method="POST"  >
                <input type="text" name='Full Name' required placeholder='Your Full Name' />
                <input type="text" name='Email' required placeholder='Your Email Address' />
                <input  type="number" onInput={(e) => e.target.value = e.target.value.slice(0, 10)} name='Phone' required placeholder='Your Mobile or Phone' />
                <input type="text" name='Address' required  placeholder='Your Address'/>
                <input type="text" name='Exp' required placeholder='Your Experience' />
                <input type="file" name="attachment" accept="image/png, image/jpeg,application/pdf,application/vnd.ms-excel"/>
 <button type="submit">Send Test</button>
            </form>
        </div>
      </div>
      
    </div>
  )
}

export default Career
